// extracted by mini-css-extract-plugin
module.exports = {"legends":"PieChart_legends__gePBL","root":"PieChart_root__1wUnX"};